import { z } from "zod";

export const tokenSchema = z.object({
  token: z.string()
});

export type LoginTokenData = z.infer<typeof tokenSchema>;